<fa-icon icon="tag"></fa-icon>
<span class="promo-code">{{ promoCode?.description }}</span>
<vnm-destroy-node-button
  [node]="record"
  [iconOnly]="true"
  icon="fa fa-fw fa-trash"
  [refetchQueries]="['LoadShoppingCart']"
  [skipConfirmation]="true"
></vnm-destroy-node-button>
